export default "__VITE_ASSET__BVAqdrN5__"